@if (isNavigating() && !formDeactivate.isGuardActive()) {
  <div class="app-loader" role="status" aria-label="Loading">
    <span class="app-loader__spinner" aria-hidden="true"></span>
    <span class="app-loader__text">Loading&hellip;</span>
  </div>
}

<router-outlet />

@if (sessionTimeoutService.showWarning()) {
  <app-session-timeout-modal
    (staySignedIn)="sessionTimeoutService.staySignedIn()"
    (signOut)="sessionTimeoutService.signOut()" />
}

<app-toast-container />

@if (ethelHost.mounted()) {
  <app-ethel-host />
}
